var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { TextStyle, Text, Spacing, BorderRadius, Colors, Icon, } from '@doordash/design-language';
import ResponsivePicture from '@doordash/component-responsive-picture';
import Button, { ButtonIconType, IconButton } from '@doordash/component-button';
import Tooltip from '@doordash/component-tooltip';
var StoreTileImageAspectRatio = {
    aspectWidth: 1.83,
    aspectHeight: 1,
};
var StoreTileImageFixedWidths = {
    Mobile: 220,
    Tablet: 220,
    Desktop: 220,
    WideScreen: 220,
};
export var EntryContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  padding: ", ";\n"], ["\n  width: 100%;\n  padding: ", ";\n"])), Spacing.None);
export var StoreImageWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n"], ["\n  width: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n"])));
export var EntryTileButtonsWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  right: ", "px;\n  margin-bottom: ", "px;\n  bottom: 0px;\n"], ["\n  position: absolute;\n  right: ", "px;\n  margin-bottom: ", "px;\n  bottom: 0px;\n"])), Spacing.XxSmall, Spacing.XxSmall);
export var StoreResponsivePicture = styled(ResponsivePicture).attrs(function () { return ({
    height: StoreTileImageAspectRatio,
    fixedWidths: StoreTileImageFixedWidths,
    loading: 'eager',
    objectFit: 'cover',
    quality: 50,
    maximumDensity: 2,
    format: 'auto',
}); })(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
export var PictureContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  height: 120px;\n  img {\n    border-radius: ", "px;\n  }\n"], ["\n  width: 100%;\n  height: 120px;\n  img {\n    border-radius: ", "px;\n  }\n"])), BorderRadius.Medium);
export var StoreImagePlaceholder = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  height: 120px;\n  border-radius: ", "px;\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"], ["\n  width: 100%;\n  height: 120px;\n  border-radius: ", "px;\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])), BorderRadius.Medium, Colors.BackgroundSecondary);
export var PhotoIcon = styled(Icon).attrs(function () { return ({
    color: Icon.Colors.TextDisabled,
    size: Icon.Sizes.XLarge,
    type: Icon.Types.PhotoLine,
}); })(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  padding-top: ", "px;\n"], ["\n  padding-top: ", "px;\n"])), Spacing.XSmall);
export var DeleteCartButton = styled(IconButton).attrs(function () { return ({
    accessibilityLabel: 'delete group order entry',
    type: IconButton.Types.Plain,
    size: IconButton.Sizes.Small,
    iconType: IconButton.IconTypes.TrashLine,
    isRaised: true,
}); })(templateObject_8 || (templateObject_8 = __makeTemplateObject([""], [""])));
export var CartCheckoutButton = styled(Button).attrs(function () { return ({
    type: Button.Types.Primary,
    size: Button.Sizes.Small,
    leadingIcon: ButtonIconType.CartLine,
    isInline: true,
}); })(templateObject_9 || (templateObject_9 = __makeTemplateObject([""], [""])));
export var CartCheckoutIconButton = styled(IconButton).attrs(function () { return ({
    accessibilityLabel: 'checkout group cart',
    type: Button.Types.Primary,
    size: Button.Sizes.Small,
    iconType: ButtonIconType.CartLine,
    isRaised: true,
}); })(templateObject_10 || (templateObject_10 = __makeTemplateObject([""], [""])));
export var JoinGroupCartButton = styled(Button).attrs(function () { return ({
    type: Button.Types.Primary,
    size: Button.Sizes.Small,
    leadingIcon: ButtonIconType.PeopleAddLine,
    isInline: true,
}); })(templateObject_11 || (templateObject_11 = __makeTemplateObject([""], [""])));
export var TrackOrderButton = styled(Button).attrs(function (props) { return ({
    type: Button.Types.Plain,
    size: Button.Sizes.Small,
    leadingIcon: props.isMobile ? null : ButtonIconType.DeliveryTruckLine,
    isInline: true,
    isRaised: true,
}); })(templateObject_12 || (templateObject_12 = __makeTemplateObject([""], [""])));
export var ViewReceiptButton = styled(Button).attrs(function (props) { return ({
    type: Button.Types.Plain,
    size: Button.Sizes.Small,
    leadingIcon: props.isMobile ? null : ButtonIconType.ReceiptLine,
    isInline: true,
    isRaised: true,
}); })(templateObject_13 || (templateObject_13 = __makeTemplateObject([""], [""])));
export var PreCheckoutText = styled(Text).attrs(function () { return ({
    styles: TextStyle.Caption2,
    color: Text.Colors.TextSecondary,
}); })(templateObject_14 || (templateObject_14 = __makeTemplateObject([""], [""])));
export var CheckoutAvailableText = styled(Text).attrs(function () { return ({
    styles: TextStyle.Caption2,
    color: Text.Colors.TextSecondary,
}); })(templateObject_15 || (templateObject_15 = __makeTemplateObject([""], [""])));
export var CheckoutInfoTooltip = styled(Tooltip).attrs(function () { return ({
    interactionType: Tooltip.InteractionTypes.ToggleHover,
    position: Tooltip.Positions.BottomCenter,
    size: Tooltip.Sizes.Small,
}); })(templateObject_16 || (templateObject_16 = __makeTemplateObject([""], [""])));
export var CartCancelledText = styled(Text).attrs(function () { return ({
    styles: TextStyle.Caption2,
    color: Text.Colors.TextSecondary,
}); })(templateObject_17 || (templateObject_17 = __makeTemplateObject([""], [""])));
export var SpendingLimitText = styled(Text).attrs(function () { return ({
    styles: TextStyle.Caption2,
    color: Text.Colors.TextSecondary,
}); })(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  visibility: ", ";\n"], ["\n  visibility: ",
    ";\n"])), function (props) {
    return props.visibility ? 'visible' : 'hidden';
});
export var EstimatedDeliveryTimeText = styled(Text).attrs(function () { return ({
    styles: TextStyle.Caption2,
    color: Text.Colors.TextSecondary,
}); })(templateObject_19 || (templateObject_19 = __makeTemplateObject([""], [""])));
export var OrderCompletedText = styled(Text).attrs(function () { return ({
    styles: TextStyle.Caption2,
    color: Text.Colors.TextSecondary,
}); })(templateObject_20 || (templateObject_20 = __makeTemplateObject([""], [""])));
export var HiddenPlaceholderForEmptyText = styled(Text).attrs(function () { return ({
    styles: TextStyle.Caption2,
    color: Text.Colors.TextSecondary,
    children: 'placeholder',
}); })(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  visibility: hidden;\n"], ["\n  visibility: hidden;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;
